module.exports = __webpack_public_path__ + "assets/talentBox2.338c39f5.svg";